import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export { joiningReportsApi } from './joiningReports'
// Legacy export name for backward compatibility
export { joiningReportsApi as joiningReportApi } from './joiningReports'
export type { JoiningReport, CreateJoiningReportData, JoiningReportFilters } from './joiningReports'

export const retirementForecastApi = {
  getForecast: (params?: { year?: number; district?: string; school_id?: string; yearsAhead?: number; page?: number; limit?: number }) => {
    return api.get('/retirement-forecast', { params })
  },
  getSummary: (params?: { year?: number; district?: string; school_id?: string; yearsAhead?: number }) => {
    return api.get('/retirement-forecast/summary', { params })
  }
}

export const vacancyProjectionApi = {
  getProjection: (params?: {
    year?: number
    district?: string
    school_level?: string
    subject?: string
    yearsAhead?: number
    page?: number
    limit?: number
    includeSchools?: boolean
  }) => {
    return api.get('/vacancy-projection', {
      params: {
        ...params,
        includeSchools: params?.includeSchools ? '1' : undefined,
      },
    })
  },
  getSummary: (params?: { year?: number; district?: string; school_level?: string; subject?: string; yearsAhead?: number }) => {
    return api.get('/vacancy-projection/summary', { params })
  }
}

export const districtShortageApi = {
  getShortage: (params?: {
    year?: number
    yearsAhead?: number
    minShortage?: number
    page?: number
    limit?: number
    district?: string
    includeSchools?: boolean
  }) => {
    return api.get('/district-shortage', {
      params: {
        ...params,
        includeSchools: params?.includeSchools ? '1' : undefined,
      },
    })
  },
  getSummary: (params?: { year?: number; yearsAhead?: number; minShortage?: number; district?: string }) => {
    return api.get('/district-shortage/summary', { params })
  }
}

export const recruitmentSuggestionsApi = {
  getSuggestions: (params?: {
    year?: number
    yearsAhead?: number
    priority?: 'high' | 'medium' | 'low' | 'all'
    category?: 'district' | 'subject' | 'school_level' | 'school' | 'all'
    district?: string
    page?: number
    limit?: number
  }) => {
    return api.get('/recruitment-suggestions', { params })
  }
}

